/*
  The share control, for the product page and the Everything page.

  The listener sits on document, not on the buttons. Horizon re-fetches the
  whole product section on every variant change, so a listener bound to a
  button is thrown away the first time somebody picks a size.

  A phone gets the phone's own share sheet, so the person picks WhatsApp,
  messages or Instagram themselves. A computer copies the link instead,
  because the Windows share sheet is usually empty and reads as broken.
  The test is the pointer, not the browser name.
*/
(function () {
  var RESET_MS = 1600;

  function isTouch() {
    return !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
  }

  function say(button, word) {
    if (button.getAttribute('data-wr-busy') === '1') return;
    var label = button.querySelector('.wr-share-label') || button;
    if (!button.getAttribute('data-wr-word')) {
      button.setAttribute('data-wr-word', label.textContent);
    }
    button.setAttribute('data-wr-busy', '1');
    label.textContent = word;
    setTimeout(function () {
      label.textContent = button.getAttribute('data-wr-word');
      button.setAttribute('data-wr-busy', '0');
    }, RESET_MS);
  }

  function copy(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      var box = document.createElement('textarea');
      box.value = text;
      box.setAttribute('readonly', '');
      box.style.cssText = 'position:fixed;top:-1000px;opacity:0';
      document.body.appendChild(box);
      box.select();
      var done = false;
      try {
        done = document.execCommand('copy');
      } catch (error) {
        done = false;
      }
      document.body.removeChild(box);
      if (done) {
        resolve();
      } else {
        reject();
      }
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var button = target.closest('[data-wr-share]');
    if (!button) return;

    /* the card is a link, so the click must not also open the product */
    event.preventDefault();
    event.stopPropagation();

    var path = button.getAttribute('data-wr-url');
    if (!path) return;

    /* resolved against the page the visitor is really on, so the link stays
       right behind the storefront password and right after the custom domain
       goes on. The base is location.href, not location.origin, because origin
       is the string "null" on a local preview file and would throw. */
    var url = path;
    try {
      url = new URL(path, window.location.href).href;
    } catch (error) {
      url = path;
    }

    var title = button.getAttribute('data-wr-title') || document.title;

    if (isTouch() && navigator.share) {
      navigator.share({ title: title, text: title, url: url }).catch(function () {});
      return;
    }

    copy(url).then(
      function () {
        say(button, 'copied.');
      },
      function () {
        say(button, 'did not copy.');
      }
    );
  });
})();
